// Owner: P1 piece 1 "Auth and passkeys" (docs/FILE-OWNERSHIP.md).
// The feature's entry file (docs/CONTRACTS.md section 16): the bare routes `/login` and `/invite`, full screen without the
// frame, each screen its own chunk. No rail entries.
import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'
import type { QueryClient } from '@tanstack/react-query'
import { sessionQuery } from '../../lib/session.ts'
import type { Feature } from '../feature.ts'

export const feature: Feature = {
  bare: (parent) => [
    createRoute({
      getParentRoute: () => parent,
      path: '/login',
      // Someone already signed in (active or pending) goes straight to the app.
      beforeLoad: async ({ context }) => {
        const session = await (context as { queryClient: QueryClient }).queryClient.fetchQuery(sessionQuery)
        if (session.kind === 'user' && !session.fixture) throw redirect({ to: '/today', replace: true })
      },
      component: lazyRouteComponent(() => import('./LoginScreen.tsx')),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/invite',
      component: lazyRouteComponent(() => import('./InviteScreen.tsx')),
    }),
  ],
  nav: [],
}
